import React from 'react';
import styled from 'styled-components';

type Props = {
  /**
   * Component to show on error.
   */
  component?: React.ComponentType<any>;
};

type State = {
  hasError: boolean;
};

const AppErrorBoundaryContainer = styled.div`
  height: 100%;
  font-size: smaller;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;

  .app-error-message {
    text-align: center;
    width: 300px;
  }
`;

const DefaultErrorComponent = () => (
  <AppErrorBoundaryContainer>
    <div className={'app-error-message'}>
      An application error has occurred. Please refresh your browser and try again. If the problem
      persists contact support at{' '}
      <a href="mailto:support@solovis.com?subject=Solovis x eVestment Application Error">
        support@solovis.com
      </a>
    </div>
  </AppErrorBoundaryContainer>
);

class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public render() {
    if (this.state.hasError) {
      const errorComponent = this.props.component ? this.props.component : DefaultErrorComponent;

      return React.createElement(errorComponent);
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
